export const estimateFormFields = [
  {
    elementId: 'ship-from-country',
    name: 'Ship From Country',
    priority: 1,
  },
  {
    elementId: 'ship-from-postal-code',
    name: 'Ship From Postal Code',
    priority: 2,
  },
  {
    elementId: 'ship-from-city',
    name: 'Ship From City',
    priority: 3,
  },
  {
    elementId: 'ship-to-country',
    name: 'Ship to Country',
    priority: 4,
  },
  {
    elementId: 'ship-to-postal-code',
    name: 'Ship to Postal Code',
    priority: 5,
  },
  {
    elementId: 'ship-to-city',
    name: 'Ship to City',
    priority: 6,
  },
  {
    elementId: 'package-type-add-package',
    name: 'Package Type',
    priority: 7,
  },
  {
    elementId: 'package-weight-add-package',
    name: 'Package Weight',
    priority: 8,
  },
  {
    elementId: 'weight-units-add-package',
    name: 'Weight Units',
    priority: 9,
  },
  {
    elementId: 'dimension-length-add-package',
    name: 'Length',
    priority: 10,
  },
  {
    elementId: 'dimension-width-add-package',
    name: 'Width',
    priority: 11,
  },
  {
    elementId: 'dimension-height-add-package',
    name: 'Height',
    priority: 12,
  },
  {
    elementId: 'dimension-units-add-package',
    name: 'Units',
    priority: 13,
  },
  {
    elementId: 'insurance-add-package',
    name: 'Insurance',
    priority: 14,
  },
  {
    elementId: 'signature-options-add-package',
    name: 'Signature Option',
    priority: 15,
  },
];
